import { render, staticRenderFns } from "./WalletView.vue?vue&type=template&id=25351712&scoped=true&"
import script from "./WalletView.vue?vue&type=script&lang=js&"
export * from "./WalletView.vue?vue&type=script&lang=js&"
import style0 from "./WalletView.vue?vue&type=style&index=0&id=25351712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25351712",
  null
  
)

export default component.exports